'use client';

import { useEffect } from 'react';

import { ampli } from '@/ampli';
import { trackEvent } from '@/configurations/tracking/track';

/**
 * Émet `DMC Viewed` sur la fiche d'un DMC réceptif, y compris quand le viewer
 * est le DMC lui-même (page « Mon catalogue ») : les auto-consultations
 * s'excluent à l'analyse en filtrant sur la user property `user_roles`, pas
 * par une event property dédiée (cf. plan de tracking Notion).
 *
 * `dmcName` n'est qu'un libellé lisible dans les charts — `dmcId` reste la
 * seule clé d'agrégation, car le nom change si le DMC est renommé.
 */
export function DmcViewTracker({ dmcId, dmcName }: { dmcId: string; dmcName?: string }) {
    useEffect(() => {
        if (!dmcId) return;

        trackEvent(() => ampli.dmcViewed({ dmc_id: dmcId, dmc_name: dmcName }));
    }, [dmcId, dmcName]);

    return null;
}
